<template>
  <div class="noise-cancel base-height">
    <header>
      <b>underConstruction </b><i class="material-icons"> warning</i>
      <h1>NOBA LAB</h1>
      <p>
        {{ $t("phrase.deeplearning") }}
      </p>
    </header>
    <div class="title">
      {{ $t("audio") }} <span>{{ $t("noise") }}</span> {{ $t("reduction") }}
    </div>
    <section v-if="file" class="player">
      <div>
        <Player :blob="file" />
      </div>
      <div v-show="progress > 0 || progress == 0" class="progress-bar">
        <progress-bar :options="options" :value="progress" />
      </div>
      <div v-show="output" class="progress-bar">
        <span>{{ filename }}</span>
        <a :href="output" download>
          <i class="material-icons">get_app</i>
        </a>
      </div>
      <div v-show="visible" class="btn-wrap">
        <button @click="handleNoiseCancel" class="btn">Noise Cancel</button>
      </div>
    </section>
    <section v-else>
      <div>
        <div class="uploader">
          <div>
            <div class="loader-container">
              <div class="rectangle-1"></div>
              <div class="rectangle-2"></div>
              <div class="rectangle-3"></div>
              <div class="rectangle-4"></div>
              <div class="rectangle-5"></div>
              <div class="rectangle-6"></div>
              <div class="rectangle-5"></div>
              <div class="rectangle-4"></div>
              <div class="rectangle-3"></div>
              <div class="rectangle-2"></div>
              <div class="rectangle-1"></div>
              <div class="rectangle-2"></div>
              <div class="rectangle-3"></div>
              <div class="rectangle-4"></div>
              <div class="rectangle-5"></div>
              <div class="rectangle-6"></div>
              <div class="rectangle-5"></div>
              <div class="rectangle-4"></div>
              <div class="rectangle-3"></div>
              <div class="rectangle-2"></div>
              <div class="rectangle-1"></div>
            </div>
            <!-- <img src="../../assets/images/sound-wave.png" alt="" /> -->
            <span class="material-icons upload-icon"></span>
            <p>Drag&Drop or <span>Choose File</span></p>
            <input
              type="file"
              class="audio-file"
              ref="audio"
              @change="sendFile('audio')"
              accept="audio/mp3, audio/ogg,audio/wav,audio/mpeg,audio/webm,audio/midi"
            />
          </div>
        </div>
        <div class="process">
          <div class="process-box">
            <i class="large material-icons">file_upload</i>
            <h1>Upload</h1>
            {{ $t("phrase.upload") }}
          </div>
          <i class="large material-icons">keyboard_arrow_right</i>
          <div class="process-box">
            <i class="large material-icons">sync</i>
            <!-- <img src="../../assets/images/processing.png"> -->
            <h1>Processing</h1>
            {{ $t("phrase.Processing") }}
          </div>
          <i class="large material-icons">keyboard_arrow_right</i>
          <div class="process-box">
            <i class="large material-icons">file_download</i>
            <h1>Download</h1>
            {{ $t("phrase.Download") }}
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="ad-box">{{ $t("advertise") }}</div>
    </section>
    <Usage />
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/wavesurfer.js/1.4.0/wavesurfer.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/wavesurfer.js/1.4.0/plugin/wavesurfer.timeline.min.js"></script>
<script>
import axios from "axios";
import ProgressBar from "vuejs-progress-bar";
import Usage from "@/components/Usage";
import Player from "@/components/Player";
import { eventBus } from "@/main";
import { baseUrl } from "@/config/env";
import {
  uploadFile,
  deleteFile,
  createNoiseCancel,
  fetchProgress,
} from "@/api/index";
import { format } from "@/mixins/format";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "RegisterProduct",
  components: { Usage, Player, ProgressBar },
  mixins: [format],
  data() {
    return {
      moment: moment,
      baseUrl: baseUrl,
      visible: true,
      title: "",
      file: "",
      output: null,
      filename: "",
      playerStatus: "none",
      recording: false,
      onPause: true,
      onPlay: false,
      title: "",
      recorder: null,
      wavesurfer: "",
      progress: null,
      setProgress: "",
      completedSteps: 0,
      totalSteps: 10,
      options: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
        },
        layout: {
          height: 35,
          width: 300,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", 0);
  },
  mounted() {
    eventBus.$on("closeModal", (message) => {
      window.console.log("closeModal111", message);
      // this.file = "";
      // this.output = "";
      // this.visible = true;
      // this.url = "";
      // this.progress = null;
      // this.setProgress = "";
      // this.stop();
      window.document.location.href = "/audio/noiseCancel";
    });
  },
  computed: {
    ...mapState(["isLogin"]),
    percent() {
      return this.progress;
    },
  },
  methods: {
    async play() {
      let src = "";
      this.onPlay = false;
      if (this.playerStatus == "ready") {
        this.playerStatus = "play";
        src = this.file;
        this.wavesurfer = "";
        this.wavesurfer = WaveSurfer.create({
          container: "#waveform",
          waveColor: "blue",
          progressColor: "orange",
          responsive: true,
          scrollParent: true,
          backgroundColor: "orange",
          closeAudioContext: true,
          showTime: true,
          numberOfInputChannels: this.numChannels,
          // plugins: [
          //   WaveSurfer.timeline.create({
          //     container: "#wave-timeline",
          //   }),
          // ],
        });
        await this.wavesurfer.load(src);
        this.wavesurfer.on("ready", () => {
          let timeline = Object.create(Wavesurfer.Timeline);
          // // let timeline = Object.create(TimelinePlugin);
          // window.console.log("tiemline", timeline);
          timeline.init({
            wavesurfer: this.wavesurfer,
            container: "#waveform-timeline",
          });
          this.wavesurfer.play();
        });
        this.wavesurfer.on("finish", () => {
          this.onPlay = true;
          this.playerStatus = "stop";
        });
      } else if (this.playerStatus == "play") {
        this.wavesurfer.pause();
        this.playerStatus = "pause";
        this.onPlay = true;
      } else {
        this.wavesurfer.play();
        this.onPlay = false;
        this.playerStatus = "play";
      }
    },
    loading() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    },
    handleNoiseCancel() {
      if (!this.isLogin) {
        return alert("로그인 후 사용 가능 합니다.");
      }
      this.progress = 0; //프로그래스 바 0% 부터 시작하도록 값을 넣어줌.
      this.visible = false; //버튼 숨김
      const formdata = new FormData();
      formdata.append("file", this.file);

      //10초에 한번씩 서버에 프로그래스 상태를 확인함.
      this.setProgress = setInterval(() => {
        fetchProgress().then((res) => {
          window.console.log(" res progress", res);
          this.progress = res.data.progress;
        });
      }, 1000);
      createNoiseCancel(formdata).then((res) => {
        if (res.data.status === 200) {
          this.stop(); //프로그래스 상태 중지
          this.progress = 100;
          this.output = res.data.data.url;
          this.filename = res.data.data.filename;
        } else if (res.data.status == 409) {
          this.progress = null;
          this.stop();
          return alert("잔여 포인트가 부족합니다. 결제 후 진행해주세요.");
        }
      });
    },
    stop() {
      clearInterval(this.setProgress);
      this.setProgress = "";
    },
    async setProgress() {
      let data = await axios.get(baseUrl + `/file/progress`);
      this.progress = data.progress;
    },
    closeUpload() {
      this.images = "";
      this.$emit("closeUpload", true);
    },
    onInputChange(e) {
      const files = e.dataTransfer.files;
      Array.from(files).forEach((file) => this.addFile(file));
    },
    OnDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.file = e.dataTransfer.files[0];
      const formdata = new FormData();
      formdata.append("file", this.file);

      let result = uploadFile(formdata);
      if (result) {
        this.addFilePath(result.data.path);
      }
    },
    sendFile() {
      this.file = this.$refs.audio.files[0];
    },
    uploadFile() {
      let file;
      file = this.$refs.audio.files[0];
      const formdata = new FormData();
      formdata.append("file", file);
      uploadFile(formdata).then((res) => {
        if (res.status === 200) {
          window.console.log(" res", res);
        }
      });
    },
    addFilePath(path) {
      this.file = path;
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  height: 350px;
  background: url("../../assets/images/main-bg.jpg") no-repeat center center;
  background-size: cover;
  color: #fff;
  padding-top: 100px;
  margin-top: 62px;
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  font-size: 1.6rem;
  letter-spacing: 1px;
  h1 {
    font-size: 4.5rem;
    letter-spacing: 0.5rem;
    margin: 2rem 0;
  }
  i {
      vertical-align:bottom;
  }
  text-align: center;
}
.title {
  font-size: 2.2rem;
  margin-top: 5rem;
  text-align: center;
  span {
    color: #ff5252;
  }
}
.uploader {
  margin: 50px auto;
  max-width: 800px;
  height: 170px;
  text-align: center;
  border: 1px solid #313da1;
  border-radius: 15px;
  background: linear-gradient(#ffffff, #f2f2f2);
  position: relative;
  &:hover {
    border: 2px solid rgb(52, 64, 153);
    cursor: pointer;
  }
  img {
    width: 400px;
    margin-top: 20px;
  }
  p {
    font-size: 1.5rem;
    color: #000;
    text-align: center;
    font-weight: 500;
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  .audio-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100% !important;
    opacity: 0%;
    &:hover {
      cursor: pointer;
    }
  }
  .loader-container {
    position: relative;
    height: 20px;
    width: 400px;
    margin: 20px auto;
    margin-top: 60px;
    > div {
      position: relative;
      display: inline-block;
      background: #03a9f4;
      height: 100%;
      width: 5px;
      margin-right: 10px;
      -webkit-animation: load 3s ease-in-out infinite;
      animation: load 3s ease-in-out infinite;
    }
    .rectangle-2 {
      -webkit-animation-delay: 0.1s;
      animation-delay: 0.1s;
    }
    .rectangle-3 {
      -webkit-animation-delay: 0.2s;
      animation-delay: 0.2s;
    }
    .rectangle-4 {
      -webkit-animation-delay: 0.3s;
      animation-delay: 0.3s;
    }
    .rectangle-5 {
      -webkit-animation-delay: 0.4s;
      animation-delay: 0.4s;
    }
    .rectangle-6 {
      -webkit-animation-delay: 0.5s;
      animation-delay: 0.5s;
    }

    @-moz-keyframes load {
      0%,
      100% {
        -moz-transform: scaleY(1);
        background: #03a9f4;
      }
      16.67% {
        -moz-transform: scaleY(3);
        background: #ff5722;
      }
      33.33% {
        -moz-transform: scaleY(1);
        background: #ff5252;
      }
      50% {
        -moz-transform: scaleY(3);
        background: #e91e63;
      }
      66.67% {
        -moz-transform: scaleY(1);
        background: #9c27b0;
      }
      83.34% {
        -moz-transform: scaleY(3);
        background: #673ab7;
      }
    }
    @-webkit-keyframes load {
      0%,
      100% {
        -webkit-transform: scaleY(1);
        background: #03a9f4;
      }
      16.67% {
        -webkit-transform: scaleY(3);
        background: #ff5722;
      }
      33.33% {
        -webkit-transform: scaleY(1);
        background: #ff5252;
      }
      50% {
        -webkit-transform: scaleY(3);
        background: #e91e63;
      }
      66.67% {
        -webkit-transform: scaleY(1);
        background: #9c27b0;
      }
      83.34% {
        -webkit-transform: scaleY(3);
        background: #673ab7;
      }
    }
    @keyframes load {
      0%,
      100% {
        transform: scaleY(1);
        background: #03a9f4;
      }
      16.67% {
        transform: scaleY(3);
        background: #ff5722;
      }
      33.33% {
        transform: scaleY(1);
        background: #ff5252;
      }
      50% {
        transform: scaleY(3);
        background: #e91e63;
      }
      66.67% {
        transform: scaleY(1);
        background: #9c27b0;
      }
      83.34% {
        transform: scaleY(3);
        background: #673ab7;
      }
    }
  }
}
.ad-box {
  max-width: 800px;
  margin: 40px auto;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 5px;
}

.player {
  .btn-wrap {
    width: 100%;
    margin: 40px auto;
    text-align: center;
    button {
      width: 200px;
      height: 40px;
      border-radius: 20px;
      color: #fff;
      background-color: #ff5252;
      border: 1px solid rgba(255, 255, 255, 0.9);
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
      text-align: center;
    }
  }
  .progress-bar {
    width: 70%;
    margin: 40px auto;
    display: flex;
    justify-content: center;
    .vuejs-progress-bar {
      width: 100%;
      text-align: center;
    }
    span {
      height: 50px;
      border: 2px solid #313da1;
      line-height: 30px;
      padding: 10px 50px;
    }
    a {
      height: 50px;
      width: 50px;
      line-height: 60px;
      background: #313da1;
      padding: 10px;
      color: #fff;
      display: flex;
      vertical-align: middle;
      i {
        margin: 0 auto;
        padding-top: 2px;
      }
    }
  }
}

@media all and (max-width: 1200px) {
  header {
    height: 250px;
    padding-top: 60px;
  }
  .uploader {
    width: calc(100% - 60px);
  }
  .ad-box {
    width: calc(100% - 60px);
    margin: 4rem auto 0;
  }
}
@media screen and (max-width: 540px) {
  header {
    height: 200px;
    padding: 30px;
    h1 {
      font-size: 4rem;
      margin: 2rem 0;
    }
  }
  .title {
    font-size: 3rem;
    margin-top: 4rem;
  }
  .uploader {
    margin: 4rem auto;
    height: 140px;
    border-radius: 0px;
    &:hover {
      border: 2px solid rgb(52, 64, 153);
      cursor: pointer;
    }
    img {
      width: 70%;
      margin-top: 30px;
    }
    p {
      width: 90%;
      font-size: 1.5rem;
      bottom: 15px;
    }
    .loader-container {
      max-width: 300px;
      margin-top: 50px;
      > div {
        margin-right: 7px;
      }
    }
  }
  .player {
    .btn-wrap {
      width: 100%;
      margin: 20px auto;
      text-align: center;
      button {
        width: 200px;
      }
    }
    .progress-bar {
      width: 100%;
      margin: 20px auto;
      span {
        height: 40px;
        line-height: 25px;
        padding: 5px 10px;
      }
      > a {
        height: 40px;
        width: 40px;
        padding: 5px;
      }
    }
  }
}
@media all and (max-width: 376px) {
  header {
    font-size: 1.5rem;
    h1 {
      font-size: 4rem;
      margin: 2rem 0;
    }
  }
  .title {
    font-size: 2.5rem;
    margin-top: 2.5rem;
  }
  .uploader {
    width: calc(100% - 20px);
    .loader-container {
      width: 90%;
      height: 15px;
      margin-top: 50px;
    }
  }
  .ad-box {
    width: calc(100% - 20px);
  }
  .player {
    .progress-bar {
      span {
        max-width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      > a {
        height: 40px;
        width: 40px;
        padding: 5px;
      }
    }
  }
}
</style>
